$(function() {
    let ref = $('#ref').val();
    let user_name = $('#user_name').val();
    let co_id = $('#co_id').val();
    let price = ''
    let text = ''
    let opcion_seleccionada = ''
    let app_type = $('#app_type').val();
    let modal_status = $('#modal_status').val();
    let deal_id = $('#deal_id').val();

    let first_name = '';
    let last_name = '';
    let email = '';
    let phone_number = '';
    
    if (modal_status && deal_id) $('#send_email_modal').modal('show');


    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $.validator.setDefaults({
        debug: true,
        onsubmit: false,
        onfocusout: false,
        invalidHandler: function (form, validator) {
            var errors = validator.numberOfInvalids();
            if (errors) {
                validator.errorList[0].element.focus();
            }
        },
        errorPlacement: function (error, element) {
            return true;
        },
        highlight: function (element, errorClass) {
            $(element).parent('.textfield').addClass('has-error');
        },
        unhighlight: function (element) {
            $(element).parent('.textfield').removeClass('has-error');
        },
    });

    $('.area_code').on('focusin', function () {
        $(this).mask("0 0000");
        if ($(this).val() == '') {
            $(this).val(0);
        }
    })
    $('.area_code').on('focusout', function () {
        if ($(this).val() == 0) {
            $(this).mask("", { placeholder: "Código de area" });
        }
    })
    $('.area_code').on('input', function () {
        let val = $(this).val();
        if (val.charAt(0) != '0') {
            $(this).val('0' + val);
        }
    })
    $('.tel_number').on('focusin', function () {
        $(this).mask("00 00000000");
        if ($(this).val() == '') {
            $(this).val(15);
        }
    })
    $('.tel_number').on('focusout', function () {
        if ($(this).val() == 15) {
            $(this).mask("", { placeholder: "Número" });
        }
    })
    $('.tel_number').on('input', function () {
        let val = $(this).val();
        if (val.length < 2) {
            $(this).val(15);
        } else {
            if (val.substring(0, 2) != '15') {
                $(this).val('15' + val);
            }
        }
    })

    var count = 0;
    var pointer = null;
    function start_progress(text = 'Procesando...') {
        $('.loader_wrapper p').text('0%');
        $('.loader_wrapper .progress-bar').css('width', '0%');
        $('.loader_wrapper h5').text(text);
        if (count == 0) {
            count = 1;
            let width = 0;
            pointer = setInterval(() => {
                if (width >= 100) {
                    clearInterval(pointer);
                    count = 0;
                    $('.loader_wrapper p').text('100%');
                    $('.loader_wrapper .progress-bar').css('width', '100%');
                } else {
                    width++;
                    $('.loader_wrapper p').text(width + '%');
                    $('.loader_wrapper .progress-bar').css('width', width + '%');
                }
            }, 200);
        }
    }

    function numberWithPoint(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    function storeActivity(app_type, action = '', bitrix = false) {
        let data = {};
        data.app_type = app_type
        data.action = action
        data.ref = ref;
        data.user_name = user_name;
        data.co_id = co_id;
        data.price = price;
        data.text = text;
        data.opcion_seleccionada = opcion_seleccionada;
        data.first_name = first_name
        data.last_name = last_name
        data.email = email
        data.phone_number = phone_number
        data.bitrix = bitrix
        data.deal_id =deal_id

        $.ajax({
            url: '/send-bitrix',
            method: 'post',
            data: data,
            dataType: 'JSON',
            beforeSend: function () {
                if (bitrix) {
                    $('.loader_wrapper').removeClass('d-none');
                    start_progress('Procesando...');
                }               
            },
            success: function (data) {
                console.log(data);
                if (bitrix) $('#confirmation_modal').modal('show');
            },
            error: function (xhr, status) {
                if (xhr.status == 419) {
                    location.reload();
                }
            },
            complete: function () {
                if (bitrix) {
                    clearInterval(pointer);
                    $('.loader_wrapper p').text('100%');
                    $('.loader_wrapper .progress-bar').css('width', '100%');
                    count = 0;
                    setTimeout(() => {
                        $('.loader_wrapper').addClass('d-none');
                    }, 700);
                    $('#send_email_modal').modal('hide');
                }
            }
        })
    }

    // Bejerman web action ------
    $('.view_deal').on('click', function() {
        text = $('.thomson-text').text();
        let temp_price = $(this).data('price')
        let temp_importe = $(this).data('Importe')

        if ((temp_price && !temp_importe) || (temp_price && temp_importe && temp_price > temp_importe)) {
            price = temp_price;
            $(this).addClass('d-none')
            $('.thmoson_price span').text(numberWithPoint(price))
            $('.thmoson_price').removeClass('d-none')
        } else {
            $('#send_email_modal').modal('show');
        }
        storeActivity(app_type, 'Ver Oferta')
    })
    $('.want_now').on('click', function() {
        text = $(this).parents('.product_content').find('.thomson-text').text();
        opcion_seleccionada = $(this).parents('.product_content').find('.thomson-text').data('opcion_seleccionada')
        if (app_type != 'bejermanweb') price = $(this).parents('.product_content').find('.thmoson_price').data('price')
        $('#send_email_modal').modal('show');
        storeActivity(app_type, text)
    })
    $('.this_module').on('click', function() {
        text = $('.thomson-text').text();
        opcion_seleccionada = $(this).data('opcion_seleccionada')
        $('#send_email_modal').modal('show');
        storeActivity(app_type, 'Quiero este módulo')
    })

    $('.contact_email').on('click', function() {
        opcion_seleccionada = $(this).data('opcion_seleccionada')
        $('#send_email_modal').modal('show');
        storeActivity(app_type, 'Quiero recibir estas propuestas por email o Whatsapp')
    })

    $('#send_email_modal_btn').on('click', function (e) {
        e.preventDefault()
        let temp_user_first_name = $('#user_first_name').val();
        let temp_user_last_name = $('#user_last_name').val();
        let temp_user_email = $('#user_email').val();
        let temp_area_code = $('#area_code').val();
        let temp_tel_number = $('#tel_number').val();
        if (temp_user_first_name == '' && temp_user_last_name == '' && temp_user_email == '' && temp_area_code == '' && temp_tel_number == '') {
            $('#send_email_modal').modal('hide');
            return;
        }
        phone_number = temp_area_code.substring(1).trim() + temp_tel_number.substring(2).trim();
        $('#personal_info_modal').validate({
            rules: {
                user_first_name: 'required',
                user_last_name: 'required',
                user_email: {
                    required: true,
                    email: true,
                },
                area_code: {
                    required: true,
                    // digits: true,
                    minlength: 4,
                    maxlength: 6
                },
                tel_number: {
                    required: true,
                    // digits: true,
                    minlength: 9,
                    maxlength: 11
                }
            }
        });

        if ($('#personal_info_modal').valid()) {
            first_name = temp_user_first_name
            last_name = temp_user_last_name
            email = temp_user_email

            storeActivity(app_type, 'Sent to bitrix', true)
        }
    })

    /** to show cascade one by one */
    function reveal(item, wrapper) {
        var verticalEdge   = wrapper.scrollTop() + wrapper.outerHeight();
        
        item.each(function() {
            if (verticalEdge >= $(this).offset().top) {
                $(this).addClass('animate');
            } else {
                // $(this).removeClass('animate');
            }
        });
    }
      
    $(window).on("load scroll", function() {
        reveal($('.cascade_show_container'), $(this));
    });
    
})